import ColorPaletteTool from '../../common/Color/ColorPaletteTool';

export default ColorPaletteTool;
